<template>
  <component-wrapper class="download-center-fi">
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12">
        <h1
          v-if="fields.headline?.value && !isEditMode"
          class="download-center-fi__headline"
        >
          {{ fields.headline?.value }}
        </h1>
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="fields.headline && isEditMode"
          class="download-center-fi__headline"
          v-html="fields.headline.editable"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </grid-container-fi>

    <template v-if="(!$apollo?.queries?.getBaseFacets?.loading && !initalLoading) || isEditMode">
      <grid-container-fi
        v-if="!isEditMode"
        class="download-center-fi__facets"
      >
        <div class="fi-col-span-full lg:fi-col-start-2 lg:fi-col-end-12">
          <div class="fi-grid fi-grid-cols-12 fi-gap-small md:fi-gap-large">
            <div class="fi-col-span-12 sm:fi-col-span-6 md:fi-col-span-4 lg:fi-col-span-3">
              <text-input-fi
                :value="query"
                :label="fields.searchLabel?.value"
                icon="search"
                :large="isSM"
                @change="searchChanged"
                @icon-clicked="searchChanged"
              />
            </div>
          </div>
        </div>
        <div class="fi-col-span-full lg:fi-col-start-2 lg:fi-col-end-12">
          <facets-menu-fi
            class="download-center-fi__facet-menu"
            :facets="documentFacets"
            :columns-max="4"
            @change="changeFacet"
            @clear-all-facets="clearAllFacets"
          >
            <template #facets="{ facet, open, change, close, toggleOpen, idx, registerDomElement }">
              <document-download-facet-fi
                :facet="facet"
                :open="open"
                :idx="idx"
                :register-dom-element="registerDomElement"
                @change="change"
                @toggle-open="toggleOpen(facet)"
                @close="close(facet)"
              />
            </template>
          </facets-menu-fi>
        </div>
      </grid-container-fi>

      <div class="download-center-fi__documents-wrapper">
        <grid-container-fi>
          <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12">
            <div
              v-if="(getDocumentListNg && documents) || isEditMode"
              class="download-center-fi__documents"
            >
              <div class="download-center-fi__documents__counter">
                {{
                  $dict.get('download-Center.Document-Downloads.Results-Counter', [
                    getDocumentListNg.resultCount,
                  ])
                }}
              </div>

              <template v-if="getDocumentListNg.resultCount > 0">
                <document-download-items-fi
                  :documents="documents"
                  theme="download-center"
                />

                <div class="download-center-fi__loading-more">
                  <infinite-loading
                    v-if="infiniteLoadingAvailable && !IS_SSR"
                    ref="infiniteLoading"
                    class="download-center-fi__spinner"
                    @infinite="fetchMore"
                  >
                    <template #spinner>
                      <div class="download-center-fi__spinner-tile">
                        <loading-indicator variant="spinnerLocal" />
                      </div>
                    </template>
                    <template #no-more><span /></template>
                    <template #no-results><span /></template>
                    <template #error><span /></template>
                  </infinite-loading>
                  <div
                    v-for="(item, idx) in placeholders"
                    :key="idx"
                    class="download-center-fi__spinner"
                  >
                    <div class="download-center-fi__spinner-tile" />
                  </div>
                </div>
              </template>
              <template v-else>
                <richtext-fi
                  class="download-center-fi__no-results"
                  :html-content="fields.noResults"
                />
              </template>
            </div>

            <div
              v-if="!isEditMode"
              class="download-center-fi__pagination"
            >
              <pagination-progress-bar
                v-if="getDocumentListNg.resultCount"
                :pagination-page="page"
                :pagination-total="getDocumentListNg.resultCount || 0"
                :progressbar-value="pagingPercentage"
                :disabled-state="Boolean($apolloData.loading)"
                :show-more-button="displayedItems < getDocumentListNg.resultCount"
                @loadmore="fetchMore"
              >
                <template v-if="page * quantity <= getDocumentListNg.resultCount">
                  <span>{{
                    $dict.get('download-Center.Pagination.Show-Sum', [
                      page * quantity,
                      getDocumentListNg.resultCount,
                    ])
                  }}</span>
                </template>

                <template v-else>
                  <span>{{
                    $dict.get('download-Center.Pagination.Show-Sum', [
                      getDocumentListNg.resultCount,
                      getDocumentListNg.resultCount,
                    ])
                  }}</span>
                </template>
              </pagination-progress-bar>
            </div>
          </div>
        </grid-container-fi>
      </div>
    </template>

    <div
      v-else
      class="download-center-fi__loading"
    >
      <loading-indicator
        variant="spinnerLocal"
        class="spinner-local--rebrush"
      />
    </div>
  </component-wrapper>
</template>

<script>
import { LoadingIndicator, PaginationProgressBar, RichtextFi, TextInputFi } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import DocumentDownloadFacetFi from 'components/document-download/document-download-facet/DocumentDownloadFacetFi';
import DocumentDownloadItemsFi from 'components/document-download/DocumentDownloadItemsFi';
import FacetsMenuFi from 'components/facets/facets-menu-fi/FacetsMenuFi';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import mergeFacets from 'components/search-fact-finder-fi/mergeFacets';
import GETDOCUMENTLIST from 'gql/getDocumentListNg.gql';
import InfiniteLoading from 'infinite-loading-vue3-ts';
import breakpointMixin from 'mixins/breakpointMixin';

// these should not be visible to the user
const technicalFacets = ['Type', 'CategoryPathName', 'ValidFrom', 'ValidUntil', 'FamilyPage'];

export default {
  name: 'DownloadCenterFi',
  components: {
    InfiniteLoading,
    PaginationProgressBar,
    ComponentWrapper,
    GridContainerFi,
    LoadingIndicator,
    TextInputFi,
    FacetsMenuFi,
    DocumentDownloadItemsFi,
    DocumentDownloadFacetFi,
    RichtextFi,
  },
  mixins: [breakpointMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      getDocumentListNg: {
        resultStatus: null,
        resultCount: 0,
        currentPage: 0,
        nextLink: null,
        facets: [],
        documents: [],
      },
      query: '',
      filters: [],
      getBaseFacets: [],
      quantity: 6,
      page: 1,
      fetchingMore: false,
      displayNewDownloadListView: false, // XXX Remove after the product data and it's interface has been updated
      initalLoading: true,
    };
  },
  computed: {
    queryTrimmed() {
      return this.query.trim();
    },
    channel() {
      return this.fields.channel?.value || this.$fischer.factFinderChannel();
    },
    language() {
      return this.fields.language?.value || this.$fischer.catalogLocale();
    },
    infiniteLoadingAvailable() {
      return (
        this.getDocumentListNg.resultCount &&
        this.displayedItems < this.getDocumentListNg.resultCount
      );
    },
    placeholders() {
      if (!this.infiniteLoadingAvailable) {
        return [];
      }
      return Array.from('x'.repeat(this.quantity - 1));
    },
    displayedItems() {
      return Math.min(this.page * this.quantity, this.getDocumentListNg.resultCount);
    },
    pagingPercentage() {
      return (100 * this.displayedItems) / this.getDocumentListNg.resultCount;
    },
    documents() {
      // <-- Remove after the product data and it's interface has been updated
      if (this.displayNewDownloadListView && this.getDocumentListNg.documents) {
        const docs = [...this.getDocumentListNg.documents];
        docs[0].Subitems = [docs[1], docs[2]];
        docs.splice(1, 2);
        return docs;
      }
      // -->
      return this.getDocumentListNg.documents;
    },
    graphQlVariables() {
      return {
        factFinderChannel: this.channel,
        baseSiteId: this.$fischer.baseSiteId(),
        language: this.language,
        filters: this.filters,
        quantity: this.quantity,
        query: encodeURIComponent(this.queryTrimmed) || '*',
      };
    },
    baseFacets() {
      return [
        ...this.getBaseFacets,
        {
          associatedFieldName: this.fields.searchLabel?.value,
          type: 'search',
          name: '',
          noMenu: true,
          elements: [
            {
              name: '',
              selected: false,
              type: 'search',
            },
          ],
        },
      ];
    },
    documentFacets() {
      let allGroups = JSON.parse(JSON.stringify(this.getDocumentListNg.facets)).map((facet) => ({
        ...facet,
        elements: facet.elements.map((element) => ({
          ...element,
          associatedFieldName: facet.associatedFieldName,
        })),
      }));

      allGroups = allGroups.filter((group) => !technicalFacets.includes(group.name));

      return mergeFacets(
        this.getDocumentListNg.facetDataUnselected || [],
        allGroups,
        this.baseFacets || [],
        this.filters,
      );
    },
    filterUrlParams() {
      const query = this.queryTrimmed;
      if (!query) {
        return this.filterUrlParamsNoQuery;
      }
      const search = this.filterUrlParamsNoQuery ? `${this.filterUrlParamsNoQuery}&` : '?';
      return `${search}query=${encodeURIComponent(query)}`;
    },
    filterUrlParamsNoQuery() {
      const search = [];

      this.filters.forEach((filter) => {
        if (filter.selectedMinValue || filter.selectedMaxValue) {
          search.push(
            `filter${encodeURIComponent(filter.associatedFieldName)}=${encodeURIComponent(
              filter.selectedMinValue,
            )}-${encodeURIComponent(filter.selectedMaxValue)}`,
          );
        } else {
          search.push(
            `filter${encodeURIComponent(filter.associatedFieldName)}=${encodeURIComponent(
              filter.name,
            )}`,
          );
        }
      });

      if (search.length === 0) {
        return '';
      }

      return `?${search.join('&')}`;
    },
  },
  apollo: {
    getDocumentListNg: {
      query: GETDOCUMENTLIST,
      variables() {
        this.parseUrlParams();

        return {
          ...this.graphQlVariables,
        };
      },
      result() {
        this.initalLoading = false;
      },
      update(data) {
        return data.getDocumentListNg;
      },
      skip() {
        return this.isEditMode;
      },
      error(error) {
        this.initalLoading = false;
        this.$store.dispatch('notifications/openGeneralErrorNotification', { vm: this });
        console.error(error);
      },
    },
    getBaseFacets: {
      query: GETDOCUMENTLIST,
      variables() {
        return {
          factFinderChannel: this.channel,
          baseSiteId: this.$fischer.baseSiteId(),
          language: this.language,
          filters: [],
          quantity: 1,
          query: '*',
        };
      },
      update(data) {
        return data.getDocumentListNg.facets;
      },
      skip() {
        return this.isEditMode;
      },
      error(error) {
        this.$store.dispatch('notifications/openGeneralErrorNotification', { vm: this });
        console.error(error);
      },
    },
  },
  methods: {
    searchChanged(value) {
      this.page = 1;
      this.query = value.trim();
      this.changeFacet();
    },
    clearAllFacets() {
      this.filters = [];
      this.searchChanged('');
      this.changeFacet();
    },
    changeFacet(...changes) {
      let filters = [...this.filters];

      changes.forEach(({ value, element: facet }) => {
        if (facet.type !== 'search') {
          // remove old filter if already active
          filters = filters.filter(
            (oldFacet) =>
              oldFacet.associatedFieldName !== facet.associatedFieldName &&
              oldFacet.text !== facet.text,
          );
          // add to active filters
          if (value) {
            filters.push({
              associatedFieldName: facet.associatedFieldName,
              selected: facet.selected,
              name: facet.text,
              type: facet.type,
            });
          }
        }
      });

      this.page = 1;

      // sort for better cache hits and consistent urls
      // there should not be too many filters, so performance overhead for localeCompare should not matter
      this.filters = filters.sort((first, second) =>
        first.associatedFieldName.localeCompare(second.associatedFieldName),
      );

      if (!IS_SSR) {
        let state = this.filterUrlParams;

        const page = this.$fischer.query('page');
        if (page) {
          state = state
            ? `${state}&page=${encodeURIComponent(page)}`
            : `?page=${encodeURIComponent(page)}`;
        }

        const customQuery = [];
        const query = this.$fischer.query();
        const filterKeys = ['filter', 'query'];
        Object.entries(query).forEach(([key, value]) => {
          if (!filterKeys.some((el) => key.startsWith(el))) {
            customQuery.push(`${key}=${encodeURIComponent(value)}`);
          }
        });

        if (customQuery.length) {
          if (this.filterUrlParams) {
            state = `${this.filterUrlParams}&${customQuery.join('&')}`;
          } else {
            state = `?${customQuery.join('&')}`;
          }
        }

        if (state !== String(window.location.search)) {
          // we want to remove the page parameter here, because the state changed
          window.history.replaceState('', '', state || '?');
        }
      }
    },
    async fetchMore({ complete, loaded }) {
      if (this.fetchingMore) {
        return;
      }
      if (this.page * this.quantity > this.getDocumentListNg.resultCount) {
        if (complete) {
          complete();
        }
        return;
      }
      this.fetchingMore = true;

      this.page += 1;
      await this.$apollo.queries.getDocumentListNg.fetchMore({
        variables: {
          ...this.graphQlVariables,
          page: this.page,
        },
      });

      this.fetchingMore = false;
      if (loaded) {
        setTimeout(loaded, 1000); // throttle paging
      }
    },
    parseUrlParams() {
      if (this.haveParsedUrlParams) {
        return;
      }
      this.haveParsedUrlParams = true;

      this.query = this.$fischer.query('query') || '';

      const pageParam = this.getPageParam(); // remember NOW, since changeFacet will change it

      const technicalFacetsLowerCase = technicalFacets.map((name) => name.toLowerCase());
      const filters = [];
      const search = this.$fischer.query();
      Object.keys(search).forEach((key) => {
        const match = /filter(.*)/.exec(key);
        if (!match) {
          return;
        }

        const [, name] = match;
        const nameLowerCase = name.toLowerCase();
        if (!name || technicalFacetsLowerCase.includes(nameLowerCase)) {
          return;
        }

        if (/[^~]~~[^~]/.test(name)) {
          const values = /^(\d+)-(\d+)/.exec(search[key]);
          if (values) {
            filters.push({
              element: {
                associatedFieldName: name,
                selectedMinValue: values[1],
                selectedMaxValue: values[2],
                selected: true,
              },
              value: true,
            });
            return;
          }
        }
        filters.push({
          element: {
            associatedFieldName: name,
            text: search[key],
            selected: true,
          },
          value: true,
        });
      });

      if (!this.categoryPathIdRoot) {
        const query = this.$fischer.query('query');
        if (query && query !== this.query) {
          this.$store.commit('search/SET_QUERY', query);
        }
      }

      this.changeFacet(...filters);

      this.page = pageParam;
      this.pageNonResponsive = pageParam;
    },
    getPageParam() {
      const queryParam = this.$fischer.query('page');
      return Number(queryParam) || 1;
    },
  },
};
</script>

<style scoped lang="scss">
@import './download-center-fi';
</style>
